import { useCallback, useEffect, useState } from 'react';
import { useForm } from './useForm';
import { useNavigate } from 'react-router-dom';
import { Cliente } from '../routes/RoutesNames';
import ClienteController from '../controllers/ClienteController';
import { getAddressData } from '../services/external/viacep/getCep';
import { removeSpecialCharacters } from '../shared/utils/helpers/string';
import { ClienteDetalheSchema } from '../schemas/ClienteDetalheSchema';
import { ClienteRequest } from '../controllers/Types';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const useCliente = (clienteId: number | null) => {
  const navigation = useNavigate();
  const [cliente, setCliente] = useState<ClienteRequest | any>({});
  const [loading, setLoading] = useState<boolean>(false);
  // @ts-ignore - .
  const { userId } = useSelector((state) => state.Authentication);

  // [14/08/2026] A tela dizia "Houve algum erro. Verifique os dados!" para TUDO - inclusive
  // quando o banco devolvia o motivo exato ("Cliente ja cadastrado no sistema, verifique!").
  // O usuario nao tinha como saber o que corrigir.
  //
  // As procs desta casa terminam a mensagem em "!" e a API corta ali (ClienteController.cs),
  // entao o que chega aqui ja e frase pronta para o usuario - nao e stack trace. Quando nao
  // vier nada, mantem o texto antigo, que ao menos nao mente.
  const mensagemDeErro = (response: any) =>
    (typeof response?.ErroDetalhado === 'string' && response.ErroDetalhado.trim()) ||
    (typeof response?.Data === 'string' && response.Data.trim()) ||
    'Houve algum erro. Verifique os dados!';

  const onSubmit = async (data: ClienteRequest) => {
    setLoading(true);
    if (clienteId) {     
      const response = await ClienteController.Atualizar({
        ...data,
        ClienteId: clienteId,
        UsuId: userId,
      });

      if (response.StatusCode === 204) {
        toast('Cliente atualizado com sucesso!', {
          type: 'success',
        });
      } else {
        toast(mensagemDeErro(response), {
          type: 'error',
        });
      }
    } else {
      const response = await ClienteController.Adicionar({
        ...data,
        Fornecedor: data.Fornecedor || 'N',
        Transportadora: data.Transportadora || 'N',
        Cliente: data.Cliente || 'N',
        Vendedor: data.Vendedor || 'N',
        Bloqueado: data.Bloqueado || 'N',
        UsuId: userId,
      });
      if (response.StatusCode === 204) {
        navigation(Cliente);
      } else {
        toast(mensagemDeErro(response), {
          type: 'error',
        });
      }
    }
    setLoading(false);
  };

  const backActions = () => {
    navigation(Cliente);
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: cliente,
    validationSchema: ClienteDetalheSchema,
  });

  const getClienteById = useCallback(async () => {
    if (!clienteId) return;
    try {
      setLoading(true);
      const Response = await ClienteController.ListarUnico(clienteId);
      console.log('Response CLIENTE LISTAR');
      console.log(Response);
      if (Response.Data) {
        //console.log(Response.Data.cli_datanascimento);
        setCliente({
          Codigo: Response.Data.cli_id,
          Nome: Response.Data.cli_nome,
          RazaoSocial: Response.Data.cli_razao,
          CpfCnpj: Response.Data.cli_cpf_cnpj,
          RgIe: Response.Data.cli_rg_ie,
          DataNascimento: Response.Data.cli_datanascimento1,
          Nacionalidade: Response.Data.cli_nacionalidade,
          Cep: Response.Data.cli_cep,
          Cidade: Response.Data.cli_cidade,
          Bairro: Response.Data.cli_bairro,
          Estado: Response.Data.cli_uf,
          Endereco: Response.Data.cli_endereco,
          Numero: Response.Data.cli_numero,
          Complemento: Response.Data.cli_complemento,
          Telefone: Response.Data.cli_telefone,
          Celular: Response.Data.cli_celular,
          Celular2: Response.Data.cli_celular2,
          Email: Response.Data.cli_email,
          ClienteAtivo: Response.Data.cli_ativo,
          GrupoCliente: Response.Data.cli_grupo,
          Fornecedor: Response.Data.cli_fornecedor,
          Transportadora: Response.Data.cli_transportadora,
          Cliente: Response.Data.cli_cliente,
          Bloqueado: Response.Data.cli_bloqueado,
          Vendedor: Response.Data.cli_vendedor
          //Site: Response.Data.cli_website,
        });     
      }

    } catch (error) {
      console.error('Error fetching user:', error);
    } finally {
      setLoading(false);
    }
  }, [clienteId]);

  useEffect(() => {
    getClienteById();
  }, [getClienteById]);

  const handleZipCode = async (value: any) => {
    form.handleChange(value);
    const zipcode = value.target.value;

    // @ts-ignore - .
    if (zipcode && removeSpecialCharacters(zipcode).length >= 8) {
      form.handleTextChange('Cep', removeSpecialCharacters(zipcode));
      setLoading(true);
      const response = await getAddressData(zipcode);

      if (response && response.uf) {
        form.handleTextChange('Cidade', response.localidade);
        form.handleTextChange('Estado', response.uf);
        form.handleTextChange('Endereco', response.logradouro);
        form.handleTextChange('Bairro', response.bairro);
      } else {
        form.handleTextChange('Cidade', '');
        form.handleTextChange('Estado', '');
        form.handleTextChange('Endereco', '');
        form.handleTextChange('Bairro', '');
      }

      setLoading(false);
    }
  };

  return {
    ...form,
    backActions,
    loading,
    handleZipCode,
  };
};

export default useCliente;
